import {IComponentOptions} from 'angular';
import {TSDocumentType} from '../../../models/enums/TSDokumentType';
import TSDokument from '../../../models/TSDokument';
import TSDownloadFile from '../../../models/TSDownloadFile';
import DVBernUtil from '../../../utils/DVBernUtil';
import {OkHtmlDialogController} from '../../dialog/OkHtmlDialogController';
import {RemoveDialogController} from '../../dialog/RemoveDialogController';
import {DvDialog} from '../../directive/dv-dialog/dv-dialog';
import DokumenteRS from '../../service/dokumenteRS.rest';
import {DownloadRS} from '../../service/downloadRS.rest';
import {UploadRS} from '../../service/uploadRS.rest';

declare let require: any;
declare let angular: any;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IPromise = angular.IPromise;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let okCancelTemplate = require('../../dialog/okCancelTemplate.html');
let okHtmlDialogTempl = require('../../dialog/okHtmlDialogTemplate.html');
let removeDialogTemplate = require('../../dialog/removeDialogTemplate.html');
require('./dv-dokumentupload.scss');

export class DVDokumentuploadComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        schadenfallid: '=',
        parentid: '=',
        documentType: '<',
        requiredDocs: '<',
        onDocAdded: '&',
        onDocRemoved: '&',
        readonly: '<',
        disableBegleittext: '<?',
        begleitText: '@?',
        buttonSymbol: '@?',
        buttonText: '@?',
        prefix: '@',
        formParent: '<?',
    };
    template = require('./dv-dokumentupload.html');
    controller = DVDokumentuploadController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DVDokumentuploadController {
    static $inject = ['DvDialog', '$log', '$translate', 'UploadRS', 'DokumenteRS', 'DownloadRS', '$q', 'REST_API', '$scope'];

    schadenfallid: string;
    parentid: string;
    requiredDocs: string;
    parentForm: IFormController;
    dokumentuploadForm: IFormController;
    onDocAdded: (paramObj: any) => void;
    onDocRemoved: (paramObj: any) => void;
    readonly: boolean;
    disableBegleittext: boolean;
    buttonSymbol: string;
    buttonText: string;
    begleitText: string;
    prefix: string;
    formParent: any;

    dokumente: TSDokument[];

    documentType: TSDocumentType;

    /* @ngInject */
    constructor(private dvDialog: DvDialog, private $log: ILogService, private $translate: ITranslateService,
                private uploadRS: UploadRS, private dokumenteRS: DokumenteRS, private downloadRS: DownloadRS,
                private $q: IQService,
                private REST_API: string, private $scope: IScope) {
        this.documentType = TSDocumentType.VORLEISTUNG_DOC;
    }

    $onInit() {
        if (this.begleitText === undefined || this.begleitText === null) {
            this.begleitText = 'UPLOAD_TEXT';
        }

        this.$scope.$watch(() => {
            return this.schadenfallid;
        }, (newValue: any, oldValue: any) => {
            if ((newValue !== oldValue)) {
                this.loadDokumente();
            }
        });

        this.$scope.$watch(() => {
            return this.requiredDocs;
        }, (newValue: any, oldValue: any) => {
            if ((newValue !== oldValue)) {
                this.checkDocCountValid();
            }
        });

        this.loadDokumente();

        if (this.formParent) {
            this.parentForm = this.formParent;
        }
    }

    uploadAnhaenge(files: any[]) {
        this.uploadAnhaengeWithType(files, this.documentType);
    }

    private uploadAnhaengeWithType(files: any[], doctype: TSDocumentType) {
        if (this.documentType) {
            let parentid = this.parentid;
            let filesTooBig: any[] = [];
            let filesNotAllowed: any[] = [];
            let filesOk: any[] = [];
            this.$log.debug('Uploading files for Schadenfall ' + parentid);
            for (let file of files) {
                this.$log.debug('File: ' + file.name + ' size: ' + file.size);
                if (!this.dokumenteRS.isFileTypeAllowedForDocumentType(file.type, this.documentType)) {
                    // Nur bestimmte FileTypes erlaubt
                    filesNotAllowed.push(file);
                } else if (file.size > 10000000) {
                    // Maximale Filegrösse ist 10MB
                    filesTooBig.push(file);
                } else {
                    filesOk.push(file);
                }
            }

            if (filesTooBig.length > 0 || filesNotAllowed.length > 0) {
                // DialogBox anzeigen für Files, welche zu gross sind!

                let returnString = '';
                returnString += this.addErrorsForArray(filesTooBig, 'FILE_ZU_GROSS');
                returnString += '</br></br>';
                returnString += this.addErrorsForArray(filesNotAllowed, 'FILETYPE_NICHT_ERLAUBT');

                this.dvDialog.showDialog(okHtmlDialogTempl, OkHtmlDialogController, {
                    title: returnString,
                    text: ''
                });
            }

            if (filesOk.length > 0) {
                this.uploadRS.uploadFile(filesOk, this.schadenfallid, parentid, doctype).then((response) => {
                    for (let obj of response) {
                        this.dokumente.push(obj);
                        this.checkDocCountValid();
                        this.notifyOnAdd(obj, parentid);
                    }
                    return response;
                });
            }
        } else {
            this.$log.warn('No type found to store file');
        }
    }

    private addErrorsForArray(array: any[], translateKey: string) {
        if (array.length > 0) {
            let returnString = this.$translate.instant(translateKey) + '<br/><br/>';
            returnString += '<ul>';
            for (let file of array) {
                returnString += '<li>';
                returnString += file.name;
                returnString += '</li>';
            }
            returnString += '</ul>';
            return returnString;
        }
        return '';
    }

    public loadDokumente() {
        this.getDokumente().then((response) => {
            this.dokumente = response;
            this.checkDocCountValid()
        });
    }

    public checkDocCountValid() {
        if (!this.isDocCountValid()) {
            this.dokumentuploadForm['doccountvalidation'].$setValidity('doccount', false);
            this.dokumentuploadForm['doccountvalidation'].$setValidity('required', false);
        } else {
            this.dokumentuploadForm['doccountvalidation'].$setValidity('doccount', true);
            this.dokumentuploadForm['doccountvalidation'].$setValidity('required', true);
        }

    }

    public isDocCountValid(): boolean {
        let mindocs = parseInt(this.requiredDocs);
        if (isNaN(mindocs)) {
            return true;
        }

        if (this.dokumente && this.dokumente.length >= mindocs) {
            return true;
        }
        return false;
    }

    public getDokumente(): IPromise<TSDokument[]> {
        if (this.documentType) {
            return this.dokumenteRS.findDocuments(
                this.schadenfallid, this.documentType, this.parentid);
        }
        return this.$q.when([]);
    }

    public download(dokument: TSDokument) {
        let attachment: boolean = false;
        this.$log.debug('download dokument ' + dokument.filename);
        let win: Window = this.downloadRS.prepareDownloadWindow();

        this.downloadRS.getAccessTokenDocument(this.schadenfallid, this.documentType, dokument.id, this.parentid).then((downloadFile: TSDownloadFile) => {
            this.$log.debug('accessToken: ' + downloadFile.accessToken);
            this.downloadRS.startDownload(downloadFile.accessToken, downloadFile.filename, attachment, win);
        });
    }

    public getThumbnailPath(dokument: TSDokument): string {
        let fallId = this.schadenfallid ? encodeURIComponent(this.schadenfallid) : undefined;
        let doctype = encodeURIComponent(TSDocumentType[this.documentType]);
        let documentId = dokument.id ? encodeURIComponent(dokument.id) : '';
        let parentID = this.parentid ? encodeURIComponent(this.parentid) : undefined;
        let url = this.REST_API + 'blobs/temp/thumbnail/fall/' + fallId + '/typ/' + doctype + '/doc/' + documentId;
        if (parentID !== undefined) {
            url = url += '?parentId=' + parentID;
        }
        return url;
    }

    public hasThumbnail(dokument: TSDokument): boolean {
        return dokument.filetype.lastIndexOf('image/', 0) === 0;
    }

    public deleteDokument(dokument: TSDokument) {
        this.$log.debug('component -> remove dokument ' + dokument.filename);
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController, {
            text: '',
            title: 'FILE_LOESCHEN'
        })
            .then(() => {   //User confirmed removal

                this.dokumenteRS.deleteDocument(this.schadenfallid, this.documentType, dokument.id, this.parentid).then(() => {
                    // replace existing object in table with returned if returned not null
                    let index = DVBernUtil.getIndexOfElementwithID(dokument, this.dokumente);
                    if (index > -1) {
                        this.dokumente.splice(index, 1);
                        this.$log.debug('removed dokument in list');
                        this.checkDocCountValid();
                        this.notifyOnDelete(dokument);

                    }
                });

            })
            .catch(() => {
            });
    }

    private notifyOnDelete(dokument: TSDokument) {
        if (angular.isFunction(this.onDocRemoved)) {
            this.onDocRemoved({document: dokument}); //callback for already stored dokument that was
                                                     // removed
        }
    }

    private notifyOnAdd(doc: TSDokument, parentid: string) {
        if (angular.isFunction(this.onDocAdded)) {
            this.onDocAdded({document: doc, parentId: parentid})
        }
    }

    private hasDoc(): boolean {
        if (this.dokumente && this.dokumente.length > 0) {
            return true;
        }
        return false;
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-dokumentupload/dv-dokumentupload.ts